import { useEffect, useMemo, useRef, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { VForm, useVForm } from "../../shered/forms";
import {
    Autocomplete, CircularProgress,
    Box, Button, Icon,
    FormControl,
    InputLabel,
    MenuItem,
    Select, Tab, Tabs,
    Paper, Typography, useTheme,
    TextField,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Tooltip
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import clsx from 'clsx';
import { ptBR } from '@mui/x-data-grid/locales';
import { DataGrid, GridActionsCellItem, GridCellParams, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { IDetalheJogadorFreeAgency, IListagemJogador, IListaJogadoresRemovidos, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { AnosTemporadas, ILstDrop, TDropOptions, UtilidadeService, lstDropDireitos, lstDropLance, lstDropTipoContratoAjustado } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { SelectManyComponent } from "../../shered/components/select/SelectMany";
import { FreeagencyService, IDadosContratacaoFreeAgency, IListaDadosLanceFreeAgency, IListagemHistoricoLance, IListagemSalarios, IListagemTimes } from "../../shered/services/api/freeAgency/FreeAgencyService";
//import UseCountdown from "../../shered/hooks/UseCountdown";
import { VTextMaskCustom } from "../../shered/forms/VTextMaskCustom";
import dayjs from 'dayjs'
import { AddTask, EditNote, HighlightOff } from "@mui/icons-material";
import { render } from "react-dom";
import moment from "moment-timezone";
import { useCookies } from "react-cookie";
//import { ContagemRegressiva } from "../../shered/components/contador/ContagemRegressiva";
//import moment from 'moment'
const optionsNumber: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
const formatNumber = new Intl.NumberFormat('pt-BR', optionsNumber);
interface IDadosTiposContratoAjustavel {

    codigo: number;
    tipo: string;
    ano1: string;
    ano2: string;
    ano3: string;
    ano4: string;
    ano5: string;
    total: string;

}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: UtilidadeService.isMobile() ? 1 : 3 }}>
                        <Grid container>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const lstPosicoes = ["PG", "SG", "SF", "PF", "C"];

// const imagensPosicao = [{
//     codigo: "PG",
//     imagem: "../../posicao_pg.png"
// }, {
//     codigo: "PF",
//     imagem: "../../posicao_pf.png"
// }, {
//     codigo: "SG",
//     imagem: "../../posicao_sg.png"
// }, {
//     codigo: "SF",
//     imagem: "../../posicao_sf.png"
// }, {
//     codigo: "C",
//     imagem: "../../posicao_c.png"
// }];

const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

    let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;

    let qtd = posicoes.split("|").length;
    let arrImagens = posicoes.split("|");

    let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
        : qtd === 2 ?
            <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
                <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
            </>
            : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
                <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
            </>

    return imgs
}

// const historicoColumns: GridColDef[] = [
//     { field: 'codigo', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header', },
//     {
//         field: 'nome',
//         headerName: 'JOGADOR',
//         editable: false,
//         flex: 1,
//         headerClassName: 'super-app-theme--header',
//     },
//     {
//         field: 'franquia',
//         headerName: 'FRANQUIA',
//         headerClassName: 'super-app-theme--header',
//         width: 150,
//         editable: false

//     },
//     {
//         field: 'valor',
//         headerName: 'VALOR',
//         editable: false,
//         headerClassName: 'super-app-theme--header',
//         flex: 1
//     },

//     {
//         field: 'periodo',
//         headerName: 'PERÍODO',
//         editable: false,
//         headerClassName: 'super-app-theme--header',
//         flex: 1
//     }
// ];


const columns: GridColDef[] = [
    {
        field: 'codigo',
        headerName: 'ID',
        flex: 1,
        //width: 90,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'nome',
        headerName: 'JOGADOR',
        editable: false,
        flex: 1,
        //width: 330,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'left',
        align: 'left'
    },
    {
        field: 'posicao_1',
        headerName: 'POSIÇÃO',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        //width: 90,
        editable: false,
        renderCell: (params) => carregaPosicao(params.row.posicao_1, params.row.posicao_2, params.row.posicao_3),
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'franquia_Direito_Liga',
        headerName: 'DIREITO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        //width: 200,
        align: 'left',
        headerAlign: 'left'
    },
    {
        field: 'tempo_Contrato_Ultimo_Lance',
        headerName: 'TEMPO CONTRATO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        //width: 90,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'valor_Ultimo_Lance',
        headerName: 'VALOR',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        //width: 110,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => moedaRealLocaleValue(params.value),
    },
    {
        field: 'quantidade_Lance_Jogador',
        headerName: 'QUANTIDADE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        //width: 110,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'franquia_Ultimo_Lance',
        headerName: 'LANCE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        //width: 200,
        align: 'left',
        headerAlign: 'left'
    },
];


const columnsTimes: GridColDef[] = [
    { field: 'codigo', headerName: 'ID', flex: 1, width: 90, headerClassName: 'super-app-theme--header' },
    {
        field: 'nome',
        headerName: 'TIME',
        flex: 1,
        width: 330,
        editable: false,
        headerClassName: 'super-app-theme--header',
    },
    {
        field: 'cap',
        headerName: 'CAP',
        flex: 1,
        width: 110,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {

            if (params.value == null) {

                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) => `${moedaRealLocaleValue(params.row.cap) || ''}`,

    },
    {
        field: 'valor_Total_Lance',
        headerName: 'VALOR LANCE',
        flex: 1,
        width: 110,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.valor_Total_Lance) || ''}`,

    },
    {
        field: 'cap_Disponivel',
        headerName: 'CAP FREE',
        flex: 1,
        editable: false,
        width: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.cap_Disponivel) || ''}`,


    },
    {
        field: 'quantidade_Slot',
        headerName: 'SLOTS',
        flex: 1,
        editable: false,
        width: 90,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",

    },
    {
        field: 'quantidade_Lance',
        headerName: 'QTD. LANCE',
        flex: 1,
        editable: false,
        width: 90,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",
    },
    {
        field: 'quantidade_Slot_Disponivel',
        headerName: 'SLOT DISPONÍVEL',
        flex: 1,
        editable: false,
        width: 90,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",

    },
    // {
    //     field: 'nome_Jogador_Escolhido',
    //     headerName: 'Nome Jogador',
    //     description: 'Nome do Jogador da Franquia escolido',
    //     sortable: false,
    //     flex:1,
    //     valueGetter: (params: GridValueGetterParams) =>
    //         `${params.row.nome_Jogador_Escolhido || ''}`,
    // },
];


const columnsSalarios: GridColDef[] = [
    { field: 'codigo', headerName: 'ID', flex: 1, minWidth: 90, headerClassName: 'super-app-theme--header' },
    {
        field: 'valor_Minimo',
        headerName: 'MÍNIMO VALOR',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.valor_Minimo) || ''}`,
    },
    {
        field: 'valor_Maximo',
        headerName: 'MÁXIMO VALOR',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.valor_Maximo) || ''}`,
    },
    {
        field: 'tempo_Minimo',
        headerName: 'MÍNIMO DURAÇÃO',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",
    },
    {
        field: 'tempo_Maximo',
        headerName: 'MÁXIMO DURAÇÃO',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",
    }
];


const opcoesColumns: GridColDef[] = [
    {
        field: 'tipo',
        headerName: 'TIPO',
        flex: 1,
        width: 330,
        editable: false,
        headerClassName: 'super-app-theme--header',
    },
    {
        field: 'ano1',
        headerName: 'ANO 1',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            formatNumber.format(Number(params.row.ano1)),
    },
    {
        field: 'ano2',
        headerName: 'ANO 2',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            formatNumber.format(Number(params.row.ano2)),
    },
    {
        field: 'ano3',
        headerName: 'ANO 3',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            formatNumber.format(Number(params.row.ano3)),
    },
    {
        field: 'ano4',
        headerName: 'ANO 4',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            formatNumber.format(Number(params.row.ano4)),
    },
    {
        field: 'ano5',
        headerName: 'ANO 5',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            formatNumber.format(Number(params.row.ano5)),
    }, {
        field: 'total',
        headerName: 'TOTAL',
        flex: 1,
        editable: false,
        minWidth: 110,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            formatNumber.format(Number(params.row.total)),
    },

];

export const ListagemDeFreeAgency: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    const [cookies, setCookie] = useCookies(["ListaLanceFreeAgency"]);
    const { themeName } = useAppThemeContext();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const buttonRef = useRef(null);
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [lstJogadores, setLstJogadores] = useState<TDropOptions[]>([]);
    const [jogadorSelecionado, setJogadorSelecionado] = useState<number>(0);
    const [valorSalarioJogador, setValorSalarioJogador] = useState<string>("");
    const [porcentagemContratoAjustavel, setPorcentagemContratoAjustavel] = useState(0);
    const [tipoPosicaoCoinfronto, setTipoPosicaoCoinfronto] = useState(0);
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [anoSelecionado, setAnoSelecionado] = useState<number>(0);
    const [opcaoContratoAjustavel, setOpcaoContratoAjustavel] = useState<number>(1);
    const [value, setValue] = useState(0);
    const [aberturaFreeAgency, setAberturaFreeAgency] = useState(false);
    const [aberturaLeilao, setAberturaLeilao] = useState(false);
    const [showGridFreeAgency, setShowGridFreeAgency] = useState(false);
    const [opcoesContratoAjustavelRows, setOpcoesContratoAjustavelRows] = useState<IDadosTiposContratoAjustavel[]>([]);
    const [rows, setRows] = useState<IListagemJogador[]>([]);
    const [codigoFreeAgency, setCodigoFreeAgency] = useState<number>(0);
    const [usuarioComissario, setUsuarioComissario] = useState(false);
    const [listaLanceFreeAgency, setListaLanceFreeAgency] = useState<IListaDadosLanceFreeAgency[]>([]);
    const [listaLanceFreeAgencyRestrito, setListaLanceFreeAgencyRestrito] = useState<IListaDadosLanceFreeAgency[]>([]);
    const [codigoJogadorFiltro, setCodigoJogadorFiltro] = useState(0);
    const [posicaoFiltro, setPosicaoFiltro] = useState("");
    const [codigofranquiaDireitoFiltro, setCodigofranquiaDireitoFiltro] = useState(0);
    const [codigofranquiaLanceFiltro, setCodigofranquiaLanceFiltro] = useState(0);
    const [contratoAjustado, setContratoAjustado] = useState(false);
    const [tipoFreeAgency, setTipoFreeAgency] = useState(0);
    const [dataFimLance, setDataFimLance] = useState<any>();
    const [dataFimLanceRestrito, setDataFimLanceRestrito] = useState<any>();
    const [desativar, setDesativar] = useState(true);
    const [atualizaDados, setAtualizaDados] = useState(true);

    const [listaHistoricoLances, setListaHistoricoLances] = useState<IListaDadosLanceFreeAgency[]>([]);
    const [listaJogadoresRemovidos, setListaJogadoresRemovidos] = useState<IListaJogadoresRemovidos[]>([]);
    const [opcoesAutoCompleteJogador1, setOpcoesAutoCompleteJogador1] = useState<TDropOptions[]>([])
    const [selectedIdComplete1, setSelectedIdComplete1] = useState<number | undefined>(0);
    const [codigoTemporada, setCodigoTemporada] = useState<number>(0);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [intervalo, setIntervalo] = useState<any>();
    //const [atualizarDados, setAtualizarDados] = useState(true);

    const autoCompleteSelectedOption1 = useMemo(() => {
        if (!selectedIdComplete1) return null;

        const selectedOption = opcoesAutoCompleteJogador1.find(opcao => opcao.codigo === selectedIdComplete1);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete1, opcoesAutoCompleteJogador1]);

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<any>()
    //     {
    //     acao: false,
    //     label: "",
    //     tipo: "info",
    //     mensagem: "",
    //     display: "none",
    //     titulo: "Atenção"
    // });

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;
        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);


    useEffect(() => {
        //let codigoDecrpt = UtilidadeService.decrypt(codigoLiga !== null ? codigoLiga : "0");

        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        setIsLoading(true);
        setRemoveLoading(false);
        const fetchData = async () => {
            await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setAberturaFreeAgency(liga.abertura_Free_Agency);
                    setAberturaLeilao(liga.abertura_Leilao);
                    //setShowGridFreeAgency(liga.abertura_Leilao);
                    setCodigoFreeAgency(liga.codigo_Free_Agency);
                    setUsuarioComissario(liga.comissario_Usuario);
                    setCodigoFranquia(liga.codigo_Franquia);
                    CarregarListaJogadores();
                    CarregarDadosFreeAgency(liga.codigo_Free_Agency, liga.codigo_Franquia, 0, true);
                    setContratoAjustado(liga.tipo_Free_Agency === 3);
                    setOpcoesContratoAjustavelRows([]);
                    setTipoFreeAgency(liga.tipo_Free_Agency);
                    setPorcentagemContratoAjustavel(Number(liga.porcentagem_Contrato_Ajustavel));
                    setTipoPosicaoCoinfronto(liga?.codigo_Tipo_Posicao_Confronto)
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });

            await JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete1)
                .then(result => {
                    const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                        .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                    setOpcoesAutoCompleteJogador1(lstDrop);
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada! 1",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });
        }

        fetchData();
    }, [codigoLiga, atualizaDados]);

    const handleRecarregarLances = () => {
        setIsLoading(true);
        setRemoveLoading(false);
        setAtualizaDados(true);
        clearInterval(intervalo);
        setListaLanceFreeAgency([]);
        CarregarDadosFreeAgency(codigoFreeAgency, codigoFranquia, 0, false);
    }

    const handleGerarContratosLances = async () => {
        await FreeagencyService.updateGerarContratosFreeAgency()
            .then((result) => {
                const dadosFreeAgency = result.dado;
                if (dadosFreeAgency) {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Contratos Gerados com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    setTimeout(() => {
                        handleRecarregarLances();
                    }, 3000);
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const handleGerarContratoLance = async (codigoLance: number) => {
        await FreeagencyService.updateGerarContratoFreeAgency(codigoLance, user.codUsuario)
            .then((result) => {
                const dadosFreeAgency = result.dado;
                if (dadosFreeAgency) {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Contrato Gerado com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    setTimeout(() => {
                        handleRecarregarLances();
                    }, 3000);
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarDadosFreeAgency = async (codigoFreeAgency: number, codigoFranquiaRest: number, aba: number, atualizarDados: boolean) => {

        await FreeagencyService.getAllPorCodigo(codigoFreeAgency)
            .then((result) => {
                const dadosFreeAgency = result.data.dado;
                if (dadosFreeAgency.lance_Free_Agency.length > 0) {
                    let obj = dadosFreeAgency.lance_Free_Agency.sort((a, b) => Number(new Date(b.data_Fim_Lance)) - Number(new Date(a.data_Fim_Lance)));
                    setDataFimLance(obj[dadosFreeAgency.lance_Free_Agency.length - 1].data_Fim_Lance);
                    PreencherDadosLocal(dadosFreeAgency.lance_Free_Agency, atualizarDados);
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

        await FreeagencyService.getAllRestritoPorCodigo(codigoFreeAgency, codigoFranquiaRest)
            .then((result) => {
                const lstFreeAgencyRestrito = result.data.dado;
                setListaLanceFreeAgencyRestrito(lstFreeAgencyRestrito);
                if (lstFreeAgencyRestrito.length > 0) {
                    let obj = lstFreeAgencyRestrito.sort((a, b) => Number(new Date(b.data_Fim_Lance)) - Number(new Date(a.data_Fim_Lance)));
                    setDataFimLanceRestrito(obj[0].data_Fim_Lance);

                }
                setIsLoading(false);
                setRemoveLoading(true);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const PreencherDadosLocal = async (lstLanceFreeAgency: IListaDadosLanceFreeAgency[], atualizar: boolean) => {
        let intervalId: any = null;
        intervalId = setInterval(async () => {
            setListaLanceFreeAgency([...lstLanceFreeAgency]);
        }, 1000);
        setIntervalo(intervalId);

    }

    const CarregarListaJogadores = async () => {
        await JogadorService.getAllPorLiga(Number(codigoLiga), codigoJogadorFiltro, posicaoFiltro, codigofranquiaDireitoFiltro, codigofranquiaLanceFiltro)
            .then((result) => {
                let resultado = result.data.dado;
                setRows(resultado);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                setLstJogadores(lstDrop);
                setOpcoesAutoCompleteJogador(lstDrop);

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados do jogador! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const handleSave = async (dados: any) => {
        setDesativar(true);
        setIsLoading(true);
        setRemoveLoading(false);
        const liga = dadosLiga !== null && dadosLiga !== undefined ? dadosLiga : null;
        if (liga === null) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            //setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        if (selectedIdComplete === 0 || selectedIdComplete === undefined) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar o jogador!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        if (valorSalarioJogador === "0" || valorSalarioJogador === undefined || valorSalarioJogador === "") {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o valor do salário!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        if (anoSelecionado === 0 || anoSelecionado === undefined) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar o(s) ano(s)!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        const valores = opcoesContratoAjustavelRows.find(f => f.codigo === opcaoContratoAjustavel);
        const dadosSalvar: IDetalheJogadorFreeAgency = {
            codigo_Franquia: liga?.codigo_Franquia,
            codigo_Free_Agency: liga?.codigo_Free_Agency,
            codigo_Jogador: Number(selectedIdComplete),
            tempo_Contrato: anoSelecionado,
            valor: valorSalarioJogador,
            codigo_Tipo_Contrato_Ajustavel: tipoFreeAgency === 3 ? opcaoContratoAjustavel : null,
            valor_Ajustavel_Ano1: tipoFreeAgency === 3 ? valores?.ano1 === "0" ? null : valores?.ano1 : null,
            valor_Ajustavel_Ano2: tipoFreeAgency === 3 ? valores?.ano2 === "0" ? null : valores?.ano2 : null,
            valor_Ajustavel_Ano3: tipoFreeAgency === 3 ? valores?.ano3 === "0" ? null : valores?.ano3 : null,
            valor_Ajustavel_Ano4: tipoFreeAgency === 3 ? valores?.ano4 === "0" ? null : valores?.ano4 : null,
            valor_Ajustavel_Ano5: tipoFreeAgency === 3 ? valores?.ano5 === "0" ? null : valores?.ano5 : null
        }

        JogadorService.CreateJogadorFreeAgency(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Lance salvo com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("0");
            })
            .catch((errors) => {
                setIsLoading(false);
                setDesativar(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);

        //CarregarDadosFreeAgency(codigoFreeAgency, codigoFranquia, newValue);
    };

    const handleNovoLance = () => {
        setDesativar(true);
        setShowGridFreeAgency(true);
    }

    const handleAumentarLeilao = (codigoLance: number) => {
        setDadosModalEvent({
            acao: true,
            label: "Aumentar",
            tipo: "info",
            mensagem: `Deseja aumentar a oferta da Free Agency? `,
            display: "none",
            titulo: "Free Agency",
            evento: "lanceFreeAgency",
            info: {
                dadosLance: listaLanceFreeAgency.filter(f => f.codigo === codigoLance),
                codigoFranquia: codigoFranquia,
                tipoFreeAgency: tipoFreeAgency,
                codigoTipoPosicaoConfronto: tipoPosicaoCoinfronto,
                porcentagemContratoAjustavel: porcentagemContratoAjustavel,
                style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
            }
        });
        setShowModalEvent(true);

        //navigate(`/liga/freeagency/detalhes/dados/${crypt}`);
        //setRedirecionar("0");
        //return;

    }

    const handleContratar = async (params: any) => {
        setIsLoading(true);
        setRemoveLoading(false);
        let dados: IDadosContratacaoFreeAgency = {
            codigo: params.codigo,
            codigo_Franquia: codigoFranquia,
            codigo_Jogador: params.codigo_Jogador,
            codigo_Free_Agency: params.codigo_Free_Agency,
            codUsuCriacao: user.codUsuario
        }
        await FreeagencyService.createContratarFreeAgency(dados)
            .then((result) => {
                console.log(result);
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: `${params.nome_Jogador} mantido na sua franquia!`,
                    display: "none",
                    titulo: "Sucesso"
                });
                handleRecarregarLances();
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível salvar os dados FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleRecusarContrato = async (params: any) => {
        setIsLoading(true);
        setRemoveLoading(false);
        let dados: IDadosContratacaoFreeAgency = {
            codigo: params.codigo,
            codigo_Franquia: codigoFranquia,
            codigo_Jogador: params.codigo_Jogador,
            codigo_Free_Agency: params.codigo_Free_Agency,
            codUsuCriacao: user.codUsuario
        }
        await FreeagencyService.updateRecusarContratoFreeAgency(dados)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: `${params.nome_Jogador} dispensado de sua franquia!`,
                    display: "none",
                    titulo: "Sucesso"
                });
                handleRecarregarLances();
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cancelar o lance da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const freeAgencyRestritoColumns: GridColDef[] = [
        // { field: 'codigo', headerName: 'CÓDIGO', width: 90, headerClassName: 'super-app-theme--header',  },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
                <img src={params.value} alt={params.value} width={45} height={50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            editable: false,
            flex: 1,
            minWidth: 110,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },

        },
        {
            field: 'posicao_Jogador_1',
            headerName: UtilidadeService.isMobile() ? 'POS.' : 'POSIÇÃO',
            headerClassName: 'super-app-theme--header',
            minWidth: 65,
            maxWidth: 65,
            sortable: false,
            editable: false,
            renderCell: (params) => carregaPosicao(params.row.posicao_Jogador_1, params.row.posicao_Jogador_2, params.row.posicao_Jogador_3),
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'valor_Ultimo_Contrato_Jogador',
            headerName: UtilidadeService.isMobile() ? 'ÚLT. CONT.' : 'ÚLT. CONTRATO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            valueFormatter: (params) => `R$${moedaRealLocaleValue(params.value)}`,
        },
        {
            field: 'franquia_Lance_Jogador',
            headerName: 'FRANQUIA',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'valor',
            headerName: 'VALOR',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            valueFormatter: (params) => `R$${moedaRealLocaleValue(params.value)}`,
        },
        {
            field: 'valor_Desconto',
            headerName: 'DESCONTO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            valueFormatter: (params) => `R$${moedaRealLocaleValue(params.value)}`,
        },
        {
            field: 'data_Fim_Lance',
            headerName: 'DATA FIM',
            editable: false,

            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            //valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {dayjs(params.value).format('DD/MM/YYYY HH:mm')}
                    </Box>
                );
            },
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Contratar"><AddTask sx={{ color: "#66bb6a" }} /></Tooltip>}
                    label="Contratar"
                    disabled={isLoading}
                    onClick={() => handleContratar(params.row)}
                />,
                <GridActionsCellItem
                    icon={<Tooltip title="Recusar"><Icon sx={{ color: "#E91309" }}>cancel</Icon></Tooltip>}
                    label="Recusar"
                    disabled={isLoading}
                    onClick={() => handleRecusarContrato(params.row)}
                />
            ]
        }
    ];

    //#region variaveis


    const [hora0, setHora0] = useState<number>(0);
    const [minuto0, setMinuto0] = useState<number>(0);
    const [segundo0, setSegundo0] = useState<number>(0);

    const [hora1, setHora1] = useState<number>(0);
    const [minuto1, setMinuto1] = useState<number>(0);
    const [segundo1, setSegundo1] = useState<number>(0);

    const [hora2, setHora2] = useState<number>(0);
    const [minuto2, setMinuto2] = useState<number>(0);
    const [segundo2, setSegundo2] = useState<number>(0);

    const [hora3, setHora3] = useState<number>(0);
    const [minuto3, setMinuto3] = useState<number>(0);
    const [segundo3, setSegundo3] = useState<number>(0);

    const [hora4, setHora4] = useState<number>(0);
    const [minuto4, setMinuto4] = useState<number>(0);
    const [segundo4, setSegundo4] = useState<number>(0);

    const [hora5, setHora5] = useState<number>(0);
    const [minuto5, setMinuto5] = useState<number>(0);
    const [segundo5, setSegundo5] = useState<number>(0);

    const [hora6, setHora6] = useState<number>(0);
    const [minuto6, setMinuto6] = useState<number>(0);
    const [segundo6, setSegundo6] = useState<number>(0);

    const [hora7, setHora7] = useState<number>(0);
    const [minuto7, setMinuto7] = useState<number>(0);
    const [segundo7, setSegundo7] = useState<number>(0);

    const [hora8, setHora8] = useState<number>(0);
    const [minuto8, setMinuto8] = useState<number>(0);
    const [segundo8, setSegundo8] = useState<number>(0);

    const [hora9, setHora9] = useState<number>(0);
    const [minuto9, setMinuto9] = useState<number>(0);
    const [segundo9, setSegundo9] = useState<number>(0);

    const [hora10, setHora10] = useState<number>(0);
    const [minuto10, setMinuto10] = useState<number>(0);
    const [segundo10, setSegundo10] = useState<number>(0);

    const [hora11, setHora11] = useState<number>(0);
    const [minuto11, setMinuto11] = useState<number>(0);
    const [segundo11, setSegundo11] = useState<number>(0);

    const [hora12, setHora12] = useState<number>(0);
    const [minuto12, setMinuto12] = useState<number>(0);
    const [segundo12, setSegundo12] = useState<number>(0);

    const [hora13, setHora13] = useState<number>(0);
    const [minuto13, setMinuto13] = useState<number>(0);
    const [segundo13, setSegundo13] = useState<number>(0);

    const [hora14, setHora14] = useState<number>(0);
    const [minuto14, setMinuto14] = useState<number>(0);
    const [segundo14, setSegundo14] = useState<number>(0);

    const [hora15, setHora15] = useState<number>(0);
    const [minuto15, setMinuto15] = useState<number>(0);
    const [segundo15, setSegundo15] = useState<number>(0);

    const [hora16, setHora16] = useState<number>(0);
    const [minuto16, setMinuto16] = useState<number>(0);
    const [segundo16, setSegundo16] = useState<number>(0);

    const [hora17, setHora17] = useState<number>(0);
    const [minuto17, setMinuto17] = useState<number>(0);
    const [segundo17, setSegundo17] = useState<number>(0);

    const [hora18, setHora18] = useState<number>(0);
    const [minuto18, setMinuto18] = useState<number>(0);
    const [segundo18, setSegundo18] = useState<number>(0);

    const [hora19, setHora19] = useState<number>(0);
    const [minuto19, setMinuto19] = useState<number>(0);
    const [segundo19, setSegundo19] = useState<number>(0);

    const [hora20, setHora20] = useState<number>(0);
    const [minuto20, setMinuto20] = useState<number>(0);
    const [segundo20, setSegundo20] = useState<number>(0);

    const [hora21, setHora21] = useState<number>(0);
    const [minuto21, setMinuto21] = useState<number>(0);
    const [segundo21, setSegundo21] = useState<number>(0);

    const [hora22, setHora22] = useState<number>(0);
    const [minuto22, setMinuto22] = useState<number>(0);
    const [segundo22, setSegundo22] = useState<number>(0);

    const [hora23, setHora23] = useState<number>(0);
    const [minuto23, setMinuto23] = useState<number>(0);
    const [segundo23, setSegundo23] = useState<number>(0);

    const [hora24, setHora24] = useState<number>(0);
    const [minuto24, setMinuto24] = useState<number>(0);
    const [segundo24, setSegundo24] = useState<number>(0);

    const [hora25, setHora25] = useState<number>(0);
    const [minuto25, setMinuto25] = useState<number>(0);
    const [segundo25, setSegundo25] = useState<number>(0);

    const [hora26, setHora26] = useState<number>(0);
    const [minuto26, setMinuto26] = useState<number>(0);
    const [segundo26, setSegundo26] = useState<number>(0);

    const [hora27, setHora27] = useState<number>(0);
    const [minuto27, setMinuto27] = useState<number>(0);
    const [segundo27, setSegundo27] = useState<number>(0);

    const [hora28, setHora28] = useState<number>(0);
    const [minuto28, setMinuto28] = useState<number>(0);
    const [segundo28, setSegundo28] = useState<number>(0);

    const [hora29, setHora29] = useState<number>(0);
    const [minuto29, setMinuto29] = useState<number>(0);
    const [segundo29, setSegundo29] = useState<number>(0);

    const [hora30, setHora30] = useState<number>(0);
    const [minuto30, setMinuto30] = useState<number>(0);
    const [segundo30, setSegundo30] = useState<number>(0);

    const [hora31, setHora31] = useState<number>(0);
    const [minuto31, setMinuto31] = useState<number>(0);
    const [segundo31, setSegundo31] = useState<number>(0);

    const [hora32, setHora32] = useState<number>(0);
    const [minuto32, setMinuto32] = useState<number>(0);
    const [segundo32, setSegundo32] = useState<number>(0);

    const [hora33, setHora33] = useState<number>(0);
    const [minuto33, setMinuto33] = useState<number>(0);
    const [segundo33, setSegundo33] = useState<number>(0);

    const [hora34, setHora34] = useState<number>(0);
    const [minuto34, setMinuto34] = useState<number>(0);
    const [segundo34, setSegundo34] = useState<number>(0);

    const [hora35, setHora35] = useState<number>(0);
    const [minuto35, setMinuto35] = useState<number>(0);
    const [segundo35, setSegundo35] = useState<number>(0);

    const [hora36, setHora36] = useState<number>(0);
    const [minuto36, setMinuto36] = useState<number>(0);
    const [segundo36, setSegundo36] = useState<number>(0);

    const [hora37, setHora37] = useState<number>(0);
    const [minuto37, setMinuto37] = useState<number>(0);
    const [segundo37, setSegundo37] = useState<number>(0);

    const [hora38, setHora38] = useState<number>(0);
    const [minuto38, setMinuto38] = useState<number>(0);
    const [segundo38, setSegundo38] = useState<number>(0);

    const [hora39, setHora39] = useState<number>(0);
    const [minuto39, setMinuto39] = useState<number>(0);
    const [segundo39, setSegundo39] = useState<number>(0);

    const [hora40, setHora40] = useState<number>(0);
    const [minuto40, setMinuto40] = useState<number>(0);
    const [segundo40, setSegundo40] = useState<number>(0);

    const [hora41, setHora41] = useState<number>(0);
    const [minuto41, setMinuto41] = useState<number>(0);
    const [segundo41, setSegundo41] = useState<number>(0);

    const [hora42, setHora42] = useState<number>(0);
    const [minuto42, setMinuto42] = useState<number>(0);
    const [segundo42, setSegundo42] = useState<number>(0);

    const [hora43, setHora43] = useState<number>(0);
    const [minuto43, setMinuto43] = useState<number>(0);
    const [segundo43, setSegundo43] = useState<number>(0);

    const [hora44, setHora44] = useState<number>(0);
    const [minuto44, setMinuto44] = useState<number>(0);
    const [segundo44, setSegundo44] = useState<number>(0);

    const [hora45, setHora45] = useState<number>(0);
    const [minuto45, setMinuto45] = useState<number>(0);
    const [segundo45, setSegundo45] = useState<number>(0);

    const [hora46, setHora46] = useState<number>(0);
    const [minuto46, setMinuto46] = useState<number>(0);
    const [segundo46, setSegundo46] = useState<number>(0);

    const [hora47, setHora47] = useState<number>(0);
    const [minuto47, setMinuto47] = useState<number>(0);
    const [segundo47, setSegundo47] = useState<number>(0);

    const [hora48, setHora48] = useState<number>(0);
    const [minuto48, setMinuto48] = useState<number>(0);
    const [segundo48, setSegundo48] = useState<number>(0);

    const [hora49, setHora49] = useState<number>(0);
    const [minuto49, setMinuto49] = useState<number>(0);
    const [segundo49, setSegundo49] = useState<number>(0);

    const [hora50, setHora50] = useState<number>(0);
    const [minuto50, setMinuto50] = useState<number>(0);
    const [segundo50, setSegundo50] = useState<number>(0);

    const [hora51, setHora51] = useState<number>(0);
    const [minuto51, setMinuto51] = useState<number>(0);
    const [segundo51, setSegundo51] = useState<number>(0);

    const [hora52, setHora52] = useState<number>(0);
    const [minuto52, setMinuto52] = useState<number>(0);
    const [segundo52, setSegundo52] = useState<number>(0);

    const [hora53, setHora53] = useState<number>(0);
    const [minuto53, setMinuto53] = useState<number>(0);
    const [segundo53, setSegundo53] = useState<number>(0);

    const [hora54, setHora54] = useState<number>(0);
    const [minuto54, setMinuto54] = useState<number>(0);
    const [segundo54, setSegundo54] = useState<number>(0);

    const [hora55, setHora55] = useState<number>(0);
    const [minuto55, setMinuto55] = useState<number>(0);
    const [segundo55, setSegundo55] = useState<number>(0);

    const [hora56, setHora56] = useState<number>(0);
    const [minuto56, setMinuto56] = useState<number>(0);
    const [segundo56, setSegundo56] = useState<number>(0);

    const [hora57, setHora57] = useState<number>(0);
    const [minuto57, setMinuto57] = useState<number>(0);
    const [segundo57, setSegundo57] = useState<number>(0);

    const [hora58, setHora58] = useState<number>(0);
    const [minuto58, setMinuto58] = useState<number>(0);
    const [segundo58, setSegundo58] = useState<number>(0);

    const [hora59, setHora59] = useState<number>(0);
    const [minuto59, setMinuto59] = useState<number>(0);
    const [segundo59, setSegundo59] = useState<number>(0);

    const [hora60, setHora60] = useState<number>(0);
    const [minuto60, setMinuto60] = useState<number>(0);
    const [segundo60, setSegundo60] = useState<number>(0);

    const [hora61, setHora61] = useState<number>(0);
    const [minuto61, setMinuto61] = useState<number>(0);
    const [segundo61, setSegundo61] = useState<number>(0);

    const [hora62, setHora62] = useState<number>(0);
    const [minuto62, setMinuto62] = useState<number>(0);
    const [segundo62, setSegundo62] = useState<number>(0);

    const [hora63, setHora63] = useState<number>(0);
    const [minuto63, setMinuto63] = useState<number>(0);
    const [segundo63, setSegundo63] = useState<number>(0);

    const [hora64, setHora64] = useState<number>(0);
    const [minuto64, setMinuto64] = useState<number>(0);
    const [segundo64, setSegundo64] = useState<number>(0);

    const [hora65, setHora65] = useState<number>(0);
    const [minuto65, setMinuto65] = useState<number>(0);
    const [segundo65, setSegundo65] = useState<number>(0);

    const [hora66, setHora66] = useState<number>(0);
    const [minuto66, setMinuto66] = useState<number>(0);
    const [segundo66, setSegundo66] = useState<number>(0);

    const [hora67, setHora67] = useState<number>(0);
    const [minuto67, setMinuto67] = useState<number>(0);
    const [segundo67, setSegundo67] = useState<number>(0);

    const [hora68, setHora68] = useState<number>(0);
    const [minuto68, setMinuto68] = useState<number>(0);
    const [segundo68, setSegundo68] = useState<number>(0);

    const [hora69, setHora69] = useState<number>(0);
    const [minuto69, setMinuto69] = useState<number>(0);
    const [segundo69, setSegundo69] = useState<number>(0);

    const [hora70, setHora70] = useState<number>(0);
    const [minuto70, setMinuto70] = useState<number>(0);
    const [segundo70, setSegundo70] = useState<number>(0);

    const [hora71, setHora71] = useState<number>(0);
    const [minuto71, setMinuto71] = useState<number>(0);
    const [segundo71, setSegundo71] = useState<number>(0);

    const [hora72, setHora72] = useState<number>(0);
    const [minuto72, setMinuto72] = useState<number>(0);
    const [segundo72, setSegundo72] = useState<number>(0);

    const [hora73, setHora73] = useState<number>(0);
    const [minuto73, setMinuto73] = useState<number>(0);
    const [segundo73, setSegundo73] = useState<number>(0);

    const [hora74, setHora74] = useState<number>(0);
    const [minuto74, setMinuto74] = useState<number>(0);
    const [segundo74, setSegundo74] = useState<number>(0);

    const [hora75, setHora75] = useState<number>(0);
    const [minuto75, setMinuto75] = useState<number>(0);
    const [segundo75, setSegundo75] = useState<number>(0);

    const [hora76, setHora76] = useState<number>(0);
    const [minuto76, setMinuto76] = useState<number>(0);
    const [segundo76, setSegundo76] = useState<number>(0);

    const [hora77, setHora77] = useState<number>(0);
    const [minuto77, setMinuto77] = useState<number>(0);
    const [segundo77, setSegundo77] = useState<number>(0);

    const [hora78, setHora78] = useState<number>(0);
    const [minuto78, setMinuto78] = useState<number>(0);
    const [segundo78, setSegundo78] = useState<number>(0);

    const [hora79, setHora79] = useState<number>(0);
    const [minuto79, setMinuto79] = useState<number>(0);
    const [segundo79, setSegundo79] = useState<number>(0);

    const [hora80, setHora80] = useState<number>(0);
    const [minuto80, setMinuto80] = useState<number>(0);
    const [segundo80, setSegundo80] = useState<number>(0);

    const [hora81, setHora81] = useState<number>(0);
    const [minuto81, setMinuto81] = useState<number>(0);
    const [segundo81, setSegundo81] = useState<number>(0);

    const [hora82, setHora82] = useState<number>(0);
    const [minuto82, setMinuto82] = useState<number>(0);
    const [segundo82, setSegundo82] = useState<number>(0);

    const [hora83, setHora83] = useState<number>(0);
    const [minuto83, setMinuto83] = useState<number>(0);
    const [segundo83, setSegundo83] = useState<number>(0);

    const [hora84, setHora84] = useState<number>(0);
    const [minuto84, setMinuto84] = useState<number>(0);
    const [segundo84, setSegundo84] = useState<number>(0);

    const [hora85, setHora85] = useState<number>(0);
    const [minuto85, setMinuto85] = useState<number>(0);
    const [segundo85, setSegundo85] = useState<number>(0);

    const [hora86, setHora86] = useState<number>(0);
    const [minuto86, setMinuto86] = useState<number>(0);
    const [segundo86, setSegundo86] = useState<number>(0);

    const [hora87, setHora87] = useState<number>(0);
    const [minuto87, setMinuto87] = useState<number>(0);
    const [segundo87, setSegundo87] = useState<number>(0);

    const [hora88, setHora88] = useState<number>(0);
    const [minuto88, setMinuto88] = useState<number>(0);
    const [segundo88, setSegundo88] = useState<number>(0);

    const [hora89, setHora89] = useState<number>(0);
    const [minuto89, setMinuto89] = useState<number>(0);
    const [segundo89, setSegundo89] = useState<number>(0);

    const [hora90, setHora90] = useState<number>(0);
    const [minuto90, setMinuto90] = useState<number>(0);
    const [segundo90, setSegundo90] = useState<number>(0);

    const [hora91, setHora91] = useState<number>(0);
    const [minuto91, setMinuto91] = useState<number>(0);
    const [segundo91, setSegundo91] = useState<number>(0);

    const [hora92, setHora92] = useState<number>(0);
    const [minuto92, setMinuto92] = useState<number>(0);
    const [segundo92, setSegundo92] = useState<number>(0);

    const [hora93, setHora93] = useState<number>(0);
    const [minuto93, setMinuto93] = useState<number>(0);
    const [segundo93, setSegundo93] = useState<number>(0);

    const [hora94, setHora94] = useState<number>(0);
    const [minuto94, setMinuto94] = useState<number>(0);
    const [segundo94, setSegundo94] = useState<number>(0);

    const [hora95, setHora95] = useState<number>(0);
    const [minuto95, setMinuto95] = useState<number>(0);
    const [segundo95, setSegundo95] = useState<number>(0);

    const [hora96, setHora96] = useState<number>(0);
    const [minuto96, setMinuto96] = useState<number>(0);
    const [segundo96, setSegundo96] = useState<number>(0);

    const [hora97, setHora97] = useState<number>(0);
    const [minuto97, setMinuto97] = useState<number>(0);
    const [segundo97, setSegundo97] = useState<number>(0);

    const [hora98, setHora98] = useState<number>(0);
    const [minuto98, setMinuto98] = useState<number>(0);
    const [segundo98, setSegundo98] = useState<number>(0);

    const [hora99, setHora99] = useState<number>(0);
    const [minuto99, setMinuto99] = useState<number>(0);
    const [segundo99, setSegundo99] = useState<number>(0);
    //#endregion

    const UseDiff = (data: Date, i: number, color: string) => {
        let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
        const distance = moment(data).diff(now);
        const second = 1000;
        const minute = second * 60;
        const hour = minute * 60;
        const day = hour * 24;

        var hourNumber = Math.floor(distance / (1000 * 60 * 60));
        var minuteNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var secondNumber = Math.floor((distance % (1000 * 60)) / 1000);

        return (
            <Grid key={i} style={{ color: color }}>
                <span>{hourNumber.toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{minuteNumber.toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{secondNumber.toString().padStart(2, "0")}</span>
            </Grid>
        )
    }


    const UseCountdown = (date: Date, i: number, color: string) => {
        const countdown = async (ind: number = i) => {
            let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
            const intervalo = moment(date).diff(now);
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;
            const dayNumber = Math.floor(intervalo / day);
            const hourNumber = Math.floor((intervalo % day) / hour);
            const minuteNumber = Math.floor((intervalo % hour) / minute);
            const secondNumber = Math.floor((intervalo % minute) / second);

            if (hourNumber >= 0 && minuteNumber >= 0 && secondNumber >= 0) {
                //setDia(dayNumber);
                eval(`setHora${i}`)(hourNumber)
                eval(`setMinuto${i}`)(minuteNumber)
                eval(`setSegundo${i}`)(secondNumber)
            }
            else {
                eval(`setHora${i}`)(0)
                eval(`setMinuto${i}`)(0)
                eval(`setSegundo${i}`)(0)
            }
        }
        const interval = setInterval(() => {
            countdown();
        }, 500);

        return (
            <Grid key={i} style={{ color: color }}>
                <span>{eval(`hora${i}`).toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{eval(`minuto${i}`).toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{eval(`segundo${i}`).toString().padStart(2, "0")}</span>
            </Grid>
        )
    }

    const handleCalculartempo = (data: Date) => {
        //let now = moment().locale('pt-BR');
        //let newDate = moment(data).locale('pt-BR');
        let now = moment().tz('America/Sao_Paulo').locale('pt-BR');
        let newDate = moment(data).tz('America/Sao_Paulo').locale('pt-BR');

        var ms = moment(newDate).diff(now.format());
        var d = moment.duration(ms);
        var h = Math.floor(d.asHours());

        if (h < 1) {
            return 1;
        }
        else if (h >= 1 && h < 6) {
            return 2;
        }
        else {
            return 3;
        }
    }

    const handleMostrarTemporizador = (data: Date) => {
        //let now = moment().locale('pt-BR');
        //let newDate = moment(data).locale('pt-BR');
        let now = moment().tz('America/Sao_Paulo').locale('pt-BR');
        let newDate = moment(data).tz('America/Sao_Paulo').locale('pt-BR');

        var ms = moment(newDate).diff(now.format());
        var d = moment.duration(ms);
        var h = Math.floor(d.asHours());

        if (h < 0) {
            return 1;
        }
        else {
            return 2;
        }
    }

    const handleCalcularOpcao = () => {
        const porcentagem = porcentagemContratoAjustavel;
        const valorPorTempo = Number(valorSalarioJogador);

        setOpcoesContratoAjustavelRows([
            {
                codigo: 1,
                tipo: "Linear",
                ano1: valorSalarioJogador.toString(),
                ano2: anoSelecionado > 1 ? valorSalarioJogador.toString() : "0",
                ano3: anoSelecionado > 2 ? valorSalarioJogador.toString() : "0",
                ano4: anoSelecionado > 3 ? valorSalarioJogador.toString() : "0",
                ano5: anoSelecionado > 4 ? valorSalarioJogador.toString() : "0",
                total: Number(Number(valorSalarioJogador) * anoSelecionado).toString()
            },
            {
                codigo: 2,
                tipo: "Progressivo",
                ano1: anoSelecionado === 1 ? valorPorTempo.toString() : anoSelecionado === 2 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : anoSelecionado === 3 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : Number(valorPorTempo - Number(Number(valorPorTempo * Number(porcentagem * 2)) / 100)).toString(),
                ano2: anoSelecionado > 1 ? anoSelecionado === 2 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : anoSelecionado === 3 ? valorPorTempo.toString() : Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
                ano3: anoSelecionado > 2 ? anoSelecionado === 4 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : anoSelecionado === 3 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : valorPorTempo.toString() : "0",
                ano4: anoSelecionado > 3 ? anoSelecionado === 4 ? Number(valorPorTempo + (Number(valorSalarioJogador) * Number(porcentagem * 2)) / 100).toString() : Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
                ano5: anoSelecionado > 4 ? Number(valorPorTempo + (Number(valorSalarioJogador) * Number(porcentagem * 2)) / 100).toString() : "0",
                total: Number(Number(valorSalarioJogador) * anoSelecionado).toString()
            },
            {
                codigo: 3,
                tipo: "Regressivo",
                ano1: anoSelecionado === 1 ? valorPorTempo.toString() : anoSelecionado === 2 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : anoSelecionado === 3 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : Number(valorPorTempo + ((Number(valorSalarioJogador)) * (porcentagem * 2)) / 100).toString(),
                ano2: anoSelecionado > 1 ? anoSelecionado === 2 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : anoSelecionado === 3 ? valorPorTempo.toString() : Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
                ano3: anoSelecionado > 2 ? anoSelecionado === 4 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : anoSelecionado === 3 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : valorPorTempo.toString() : "0",
                ano4: anoSelecionado > 3 ? anoSelecionado === 4 ? Number(valorPorTempo - Number(Number(valorPorTempo * Number(porcentagem * 2)) / 100)).toString() : Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
                ano5: anoSelecionado > 4 ? Number(valorPorTempo - Number(Number(valorPorTempo * Number(porcentagem * 2)) / 100)).toString() : "0",
                total: Number(Number(valorSalarioJogador) * anoSelecionado).toString()
            }
        ]);

        setDesativar(false);
    }

    const handleDisableSave = () => {
        setDesativar(contratoAjustado ? true : false);
        setOpcoesContratoAjustavelRows([]);
    }

    //Aba Histórico
    const columnsHistorico: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: 75,
            //width: 90,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: false,
            //width: 90,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            description: 'Nome do Jogador da Franquia escolhido',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 170,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        {
            field: 'posicao_Jogador',
            headerName: 'POSIÇÃO',
            sortable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 90,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (carregaPosicao(params.row.posicao_Jogador_1, params.row.posicao_Jogador_2, params.row.posicao_Jogador_3))
        },
        {
            field: "data_Fim_Lance",
            headerName: "DATA",
            flex: 1,
            minWidth: 90,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {dayjs(params.value).format('DD/MM/YYYY HH:mm')}
                    </Box>
                );
            },
        },
        // {
        //     field: "restrito_Jogador",
        //     headerName: "RESTRITO",
        //     flex: 1,
        //     minWidth: 80,
        //     editable: false,
        //     sortable: UtilidadeService.isMobile() ? false : true,
        //     headerClassName: 'super-app-theme--header',
        //     align: "center",
        //     headerAlign: "center",
        //     renderCell: (params) =>
        //     (
        //         <>
        //             <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: params.value !== "Fora" ? "yellow" : "red", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
        //             &nbsp;&nbsp;<Typography style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}> {params.value}</Typography>
        //         </>
        //     )
        // },
        {
            field: 'logo_Franquia_Direitos_Jogador',
            headerName: 'DIREITO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 130,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => <Grid container size={12} display={"flex"} justifyContent={"center"}>
                <Grid size={12} display={"flex"} justifyContent={"center"}>
                    <span style={{ color: params.row.vencedor ? '#118f3dff' : params.row.codigo_Franquia_Direitos_Jogador === params.row.codigo_Franquia ? "#4864E8" : "auto" }}>{params.row.franquia_Direitos_Jogador}</span>
                </Grid>
                <Grid size={12} display={"flex"} justifyContent={"center"}>{
                    (params.value !== null && params.value !== "" && params.value !== undefined)
                        ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "../../../../semimagemescudo.png";
                                currentTarget.style.borderRadius = "50%";
                                currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                            }}
                        />
                        : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />
                }
                </Grid>
            </Grid>,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'logo_Franquia_Lance_Jogador',
            headerName: 'LANCE',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 130,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) =>
                <Grid container size={12} display={"flex"} justifyContent={"center"}>
                    <Grid size={12} display={"flex"} justifyContent={"center"}>
                        <span style={{ color: params.row.vencedor ? '#118f3dff' : params.row.codigo_Franquia_Direitos_Jogador === params.row.codigo_Franquia ? "#4864E8" : "auto" }}>{params.row.franquia_Lance_Jogador}</span>
                    </Grid>
                    <Grid size={12} display={"flex"} justifyContent={"center"}>{
                        (params.value !== null && params.value !== "" && params.value !== undefined)
                            ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = "../../../../semimagemescudo.png";
                                    currentTarget.style.borderRadius = "50%";
                                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                }}
                            />
                            : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />
                    }
                    </Grid>
                </Grid>,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'valor',
            headerName: 'VALOR',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 90,
            maxWidth: UtilidadeService.isMobile() ? 70 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'right',
            headerAlign: 'center',
            renderCell: (params) =>
                <Grid container display={"flex"} justifyContent={"right"}>
                    <Grid size={12} display={"flex"} justifyContent={"right"}>
                        {formatNumber.format(Number(params.value))}
                    </Grid>
                    <Grid size={12} sx={{ color: "orange" }} display={"flex"} justifyContent={"right"}>{
                        params.row.valor_Descontado_Restrito !== null && params.row.valor_Descontado_Restrito !== undefined ?
                            formatNumber.format(Number(params.row.valor_Descontado_Restrito))
                            : params.row.valor_Descontado_Direito !== null && params.row.valor_Descontado_Direito !== undefined ?
                                formatNumber.format(Number(params.row.valor_Descontado_Direito)) : ""
                    }
                    </Grid>
                </Grid>

        },
        {
            field: 'codigo_Temporada',
            headerName: 'TEMPORADA',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            //maxWidth: UtilidadeService.isMobile() ? 120 : 160,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? lstTemporadas.find(f => f.codigo === params.value)?.label : "-"
        },
        {
            field: 'vencedor',
            headerName: 'VENCEDOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 110,
            //maxWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value ? "SIM" : "NÃO",
            // cellClassName: (params: GridCellParams<any, number>) => {
            //     if (params.value === null) {
            //         return '';
            //     }

            //     return clsx('super-app', {
            //         negative: !params.value,
            //         positive: params.value,
            //     });
            // },
        },

        // {
        //     field: 'superada',
        //     headerName: 'SUPERADO',
        //     editable: false,
        //     headerClassName: 'super-app-theme--header',
        //     flex: 1,
        //     minWidth: UtilidadeService.isMobile() ? 70 : 110,
        //     //maxWidth: UtilidadeService.isMobile() ? 120 : 180,
        //     sortable: UtilidadeService.isMobile() ? false : true,
        //     align: 'center',
        //     headerAlign: 'center',
        //     renderCell: (params) => params.value ? "SIM" : "NÃO"
        // },
    ];

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    const CarregarDadosHistoricoFreeAgency = async () => {
        setIsLoading(true);
        setRemoveLoading(false);
        await FreeagencyService.getAllHistoricoLanca(Number(selectedIdComplete1), Number(codigoLiga), codigoTemporada)
            .then((result) => {
                const lstFreeAgencyRestrito = result.data.dado;
                setListaHistoricoLances(lstFreeAgencyRestrito);
                setIsLoading(false);
                setRemoveLoading(true);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do histórico da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const RemoverJogadores = async () => {
        setIsLoading(true);
        setRemoveLoading(false);
        await JogadorService.deleteRemoverJogadores(Number(codigoLiga), Number(user.codUsuario))
            .then((result) => {
                console.log(result);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Jogadores removidos com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                setRemoveLoading(true);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do histórico da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarJogadoresRemovidos = async (codigoTemp: number) => {
        setCodigoTemporada(codigoTemp);
        setIsLoading(true);
        setRemoveLoading(false);
        await JogadorService.getCarregarJogadoresRemovidos(Number(codigoLiga), codigoTemp)
            .then((result) => {
                const lst = result.dado;
                setListaJogadoresRemovidos(lst);
                //setListaHistoricoLances(lstFreeAgencyRestrito);
                setIsLoading(false);
                setRemoveLoading(true);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do histórico da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const columnsJogadoresRemovidos: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: 75,
            //width: 90,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: false,
            //width: 90,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            description: 'Nome do Jogador da Franquia escolhido',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 170,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        {
            field: 'posicao_Jogador',
            headerName: 'POSIÇÃO',
            sortable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 90,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (carregaPosicao(params.row.posicao_Jogador, null, null))
        },
        {
            field: "dtCriacao",
            headerName: "DATA",
            flex: 1,
            minWidth: 90,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {dayjs(params.value).format('DD/MM/YYYY HH:mm')}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia',
            headerName: 'LOGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 130,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => <Grid container size={12} display={"flex"} justifyContent={"center"}>
                <Grid size={12} display={"flex"} justifyContent={"center"}>
                    <span style={{ color: params.row.vencedor ? '#118f3dff' : params.row.codigo_Franquia_Direitos_Jogador === params.row.codigo_Franquia ? "#4864E8" : "auto" }}>{params.row.franquia_Direitos_Jogador}</span>
                </Grid>
                <Grid size={12} display={"flex"} justifyContent={"center"}>{
                    (params.value !== null && params.value !== "" && params.value !== undefined)
                        ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "../../../../semimagemescudo.png";
                                currentTarget.style.borderRadius = "50%";
                                currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                            }}
                        />
                        : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />
                }
                </Grid>
            </Grid>,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 130,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'codigo_Temporada',
            headerName: 'TEMPORADA',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            //maxWidth: UtilidadeService.isMobile() ? 120 : 160,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? lstTemporadas.find(f => f.codigo === params.value)?.label : "-"
        },
    ];

    return (
        <LayoutBaseDePagina
            titulo={`Lance Free Agency - ${dadosLiga?.nome}`}
            showLogoImg={dadosLiga?.caminho_Logo !== undefined ? dadosLiga?.caminho_Logo : showImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    //aoClicarEmApagar={() => handleDelete(Number(codigoFranquia))}
                    aoClicarEmNovo={() => navigate("/freeagency/detalhe/nova")}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            <VForm ref={formRef}
                onSubmit={handleSave}
            >
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined"  >
                    <Grid container direction="column" padding={UtilidadeService.isMobile() ? 1 : 2} spacing={UtilidadeService.isMobile() ? 1 : 2}>
                        <Grid container display="initial" alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} onChange={handleChangeTabs}>
                                        <Tab label="Lance" {...a11yProps(0)} />
                                        <Tab label="Histórico" {...a11yProps(1)} />
                                        <Tab label="Remoção Jogadores" {...a11yProps(2)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    {aberturaFreeAgency ? (
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            <Grid container size={{ xs: 12, sm: 12 }} justifyContent="center" direction="row" >
                                                <Grid size={{ xs: 6, sm: 6, md: 3 }} display="flex" alignItems="start" justifyContent="start" style={{ padding: 8 }} >
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={handleNovoLance}
                                                        endIcon={<Icon>add</Icon>}
                                                        disabled={isLoading}
                                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14 }}
                                                    >
                                                        Novo Lance
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 3 }} display="flex" alignItems="start" justifyContent="start" style={{ padding: 8 }} >
                                                    <Button
                                                        color="success"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={handleRecarregarLances}
                                                        endIcon={<Icon>cached</Icon>}
                                                        disabled={isLoading}
                                                        style={{ color: "white", fontSize: UtilidadeService.isMobile() ? 13 : 14 }}
                                                    >
                                                        Atualizar Lances
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 3 }} display="flex" alignItems="start" justifyContent="start" style={{ padding: 8 }} >
                                                    <Button
                                                        color="success"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={handleGerarContratosLances}
                                                        endIcon={<EditNote />}
                                                        disabled={isLoading}
                                                        style={{ color: "white", fontSize: UtilidadeService.isMobile() ? 13 : 14 }}
                                                    >
                                                        Gerar Contratos
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                {listaLanceFreeAgencyRestrito.length > 0 && (
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" >
                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                            <Typography variant="h6">Free Agency Restrito</Typography>
                                                            <hr />
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                }
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    autoHeight
                                                                    getRowId={(rows) => rows.codigo}
                                                                    rows={listaLanceFreeAgencyRestrito}
                                                                    columns={freeAgencyRestritoColumns}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 20,
                                                                                //page: paginaRestrito,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[20]}
                                                                    disableRowSelectionOnClick
                                                                    disableVirtualization
                                                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                            {!showGridFreeAgency && (
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} paddingBottom={2} paddingTop={1}>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6">Lances</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={0}>
                                                        {!removeLoading && <Loading />}
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12, md: 12 }} marginTop={2} paddingTop={3}  >
                                                        {listaLanceFreeAgency.length > 0 && listaLanceFreeAgency.sort(function (a, b) { return Number(a.codigo) - Number(b.codigo) })
                                                            .slice(0, 150)
                                                            .map((r, i) => (
                                                                UtilidadeService.isMobile() ?
                                                                    (
                                                                        <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: "100%" }}>
                                                                            <CardContent sx={{ padding: 1, paddingBottom: 1, backgroundColor: "#252525", color: "white" }} >
                                                                                <Grid container size={{ xs: 12, sm: 4, md: 2 }} display="flex" justifyContent="center" textAlign="center" paddingBottom={1}>
                                                                                    <Grid size={{ xs: 6 }}>
                                                                                        <Typography variant="body2" style={{ fontSize: 13 }} sx={{ color: handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white", }}>
                                                                                            Duração (Hrs):
                                                                                        </Typography>
                                                                                        {handleMostrarTemporizador(r.data_Fim_Lance) === 1 ?
                                                                                            UseCountdown(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white")
                                                                                            : UseDiff(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white")}
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 6 }}>
                                                                                        <Typography variant="body1" style={{ fontSize: 13 }}>
                                                                                            Tempo Final
                                                                                        </Typography>
                                                                                        <Typography variant="body2" style={{ fontSize: 12 }}>
                                                                                            {new Date(r.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(r.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid size={{ xs: 12 }}>
                                                                                    <hr />
                                                                                </Grid>
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                    <Grid size={{ xs: 2 }} display="flex" >
                                                                                        <img src={r.foto_Jogador} alt={r.nome_Jogador} width={50} height={50} />
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 10 }} display="flex" >
                                                                                        <Grid size={{ xs: 12 }}>
                                                                                            <Typography key={`ty${i}2`} variant="body1" style={{ fontSize: 14 }}>
                                                                                                Jogador: {r.nome_Jogador} <span style={{ color: "#ED59BC" }}>{r.restrito_Jogador === true ? "®" : r.draftado === true ? <span style={{ color: "#6abdcb" }}>Ð</span> : ""}</span>
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid size={{ xs: 12 }}>
                                                                                            <Typography key={`ty${i}3`} display={"none"} variant="body1" style={{ fontSize: 14 }} >
                                                                                                Último Contrato: R${r.valor_Ultimo_Contrato_Jogador !== "0" ? moedaRealLocaleValue(r.valor_Ultimo_Contrato_Jogador) : r.valor_Ultimo_Contrato_Jogador}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid size={{ xs: 12 }}>
                                                                                            <Typography key={`ty${i}4`} variant="body1" style={{ fontSize: 14, display: "flex", justifyContent: "flex-start" }}>
                                                                                                Posição: <span style={{ paddingLeft: "4px" }}>{carregaPosicao(r.posicao_Jogador_1, r.posicao_Jogador_2, r.posicao_Jogador_3)}</span>
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" justifyContent={"center"} alignItems={"center"} textAlign={"center"}>
                                                                                    <Grid size={{ xs: 6 }} padding={1}  >
                                                                                        <Typography variant="body1" style={{ fontSize: 14, fontWeight: "bold" }}>
                                                                                            Valor Lance
                                                                                        </Typography>
                                                                                        <Typography variant="body2" style={{ fontWeight: "bold" }}>
                                                                                            R${moedaRealLocaleValue(r.valor)}
                                                                                            {r.valor_Descontado_Restrito !== null && r.valor_Descontado_Restrito !== undefined ?
                                                                                                <span style={{ color: "orange" }}> (R${moedaRealLocaleValue(r.valor_Descontado_Restrito)})</span>
                                                                                                : r.valor_Descontado_Direito !== null && r.valor_Descontado_Direito !== undefined ?
                                                                                                    <span style={{ color: "orange" }}> (R${moedaRealLocaleValue(r.valor_Descontado_Direito)} )</span> : null}

                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 6 }} padding={1}  >
                                                                                        <Typography variant="body1" style={{ fontSize: 14 }}>
                                                                                            Contrato
                                                                                        </Typography>
                                                                                        <Typography variant="body2" style={{ fontSize: 14 }}>
                                                                                            {r.tempo_Contrato} Anos
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" justifyContent={"center"} alignItems={"center"} >
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 3 }} display="flex"  >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                            <Box width="100%" display="flex" flexDirection="row" justifyItems="center" alignItems="center">
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center" textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        <Typography variant="body1" style={{ fontSize: 14 }}>
                                                                                                            Franquia Lance
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" style={{ fontSize: 13 }}>
                                                                                                            <span style={{ color: r.codigo_Franquia === codigoFranquia ? "#66bb6a" : "white" }}> {r.franquia_Lance_Jogador}</span>
                                                                                                        </Typography>
                                                                                                        <img src={r.logo_Franquia_Lance_Jogador === null ? showImagemFranquia : r.logo_Franquia_Lance_Jogador} alt={r.franquia_Lance_Jogador} width={50} height={50} />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent={"center"} textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        {r.franquia_Direitos_Jogador !== null ? (
                                                                                                            <><Typography variant="body1" style={{ fontSize: 14 }} >
                                                                                                                Franquia Direitos
                                                                                                            </Typography>
                                                                                                                <Typography variant="body2" style={{ fontSize: 13 }}>
                                                                                                                    <span style={{ color: r.codigo_Franquia_Direitos_Jogador === codigoFranquia ? "#117ED9" : "white" }}> {r.franquia_Direitos_Jogador}</span>
                                                                                                                </Typography>
                                                                                                                <img src={r.logo_Franquia_Direitos_Jogador === null ? showImagemFranquia : r.logo_Franquia_Direitos_Jogador} alt={r.franquia_Direitos_Jogador} width={50} height={50} />
                                                                                                            </>
                                                                                                        ) : <Typography variant="body1" >
                                                                                                            Livre
                                                                                                        </Typography>}
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12 }} display="flex" justifyContent="center" alignItems="center"  >
                                                                                        <Grid container size={{ xs: 12 }}
                                                                                            display={(user.codUsuario === r.codUsuCriacao || moment.tz(r.data_Fim_Lance,'America/Sao_Paulo') <= moment().tz('America/Sao_Paulo').locale('pt-BR') || r.aprovacao_Restrito) ? "none" : "flex"}
                                                                                            direction="column"
                                                                                            flex={2}
                                                                                        >
                                                                                            <Grid style={{ marginTop: "24px" }}>
                                                                                                <Button
                                                                                                    color="success"
                                                                                                    variant="outlined"
                                                                                                    disableElevation
                                                                                                    fullWidth
                                                                                                    onClick={() => handleAumentarLeilao(r.codigo !== undefined ? r.codigo : 0)}
                                                                                                    startIcon={<Icon>check</Icon>}
                                                                                                    disabled={isLoading}
                                                                                                >
                                                                                                    <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                                                        Aumentar
                                                                                                    </Typography>
                                                                                                </Button>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                        {r.aprovacao_Restrito && (
                                                                                            <Grid container size={{ xs: 12, sm: 6, md: 6 }} display={!r.aprovacao_Restrito ? "none" : "flex"} justifyContent={"center"} direction="column" flex={2}>
                                                                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                    <Typography variant="body1" whiteSpace="pre-wrap" textOverflow="ellipsis" overflow="hidden" style={{ color: "#66bb6a", fontSize: 14, textAlign: "center", paddingTop: "8px" }}>
                                                                                                        Aguardando a aprovação {r.franquia_Direitos_Jogador}
                                                                                                    </Typography>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        )}
                                                                                         {(user.administrador || //usuarioComissario ||
                                                                                            (
                                                                                                moment.tz(r.data_Fim_Lance,'America/Sao_Paulo') <= moment().tz('America/Sao_Paulo').locale('pt-BR')
                                                                                                && (codigoFranquia === r.codigo_Franquia || codigoFranquia === r.codigo_Franquia_Direitos_Jogador)
                                                                                            ))
                                                                                            && (
                                                                                                <Grid style={{ marginTop: "24px" }}>
                                                                                                    <Button
                                                                                                        color="success"
                                                                                                        variant="outlined"
                                                                                                        disableElevation
                                                                                                        fullWidth
                                                                                                        onClick={() => handleGerarContratoLance(r.codigo !== undefined ? r.codigo : 0)}
                                                                                                        startIcon={<Icon>check</Icon>}
                                                                                                        disabled={isLoading}
                                                                                                    >
                                                                                                        <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                                                            Finalizar Lance
                                                                                                        </Typography>
                                                                                                    </Button>
                                                                                                </Grid>
                                                                                            )}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    )
                                                                    :
                                                                    (
                                                                        <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: "100%" }}>
                                                                            {/* <CardActionArea > */}
                                                                            <CardContent sx={{ padding: 1, paddingBottom: 1, backgroundColor: "#252525", color: "white" }} >
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" flexDirection="column">
                                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                                            {/* <Typography key={`ty${i}1`} variant="h6" > */}
                                                                                            <img src={r.foto_Jogador} alt={r.nome_Jogador} width={UtilidadeService.isMobile() ? 40 : 50} height={UtilidadeService.isMobile() ? 40 : 50} />
                                                                                            {/* </Typography> */}
                                                                                            <Typography key={`ty${i}2`} variant="body1">
                                                                                                Nome Jogador: {r.nome_Jogador} <span style={{ color: "#ED59BC" }}>{r.restrito_Jogador === true ? "®" : r.draftado === true ? <span style={{ color: "#6abdcb" }}>Ð</span> : ""}</span>
                                                                                            </Typography>
                                                                                            <Typography key={`ty${i}3`} variant="body1" style={{ color: "#a5a5a5" }}>
                                                                                                Último Contrato: R${r.valor_Ultimo_Contrato_Jogador !== "0" ? moedaRealLocaleValue(r.valor_Ultimo_Contrato_Jogador) : r.valor_Ultimo_Contrato_Jogador}
                                                                                            </Typography>
                                                                                            <Typography key={`ty${i}4`} variant="body1" style={{ display: "flex", justifyContent: "flex-start" }}>
                                                                                                Posição: <span style={{ paddingLeft: "4px" }}>{carregaPosicao(r.posicao_Jogador_1, r.posicao_Jogador_2, r.posicao_Jogador_3)}</span>
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 2 }} display="flex"  >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                            <Box width="100%" display="flex" flexDirection="row" justifyItems="center" alignItems="center">
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center" textAlign="center" direction="row">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        <Typography variant="body1" style={{ fontWeight: "bold" }}>
                                                                                                            Valor Lance
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" style={{ fontWeight: "bold" }}>
                                                                                                            R${moedaRealLocaleValue(r.valor)}
                                                                                                            {r.valor_Descontado_Restrito !== null && r.valor_Descontado_Restrito !== undefined ?
                                                                                                                <span style={{ color: "orange" }}> (R${moedaRealLocaleValue(r.valor_Descontado_Restrito)})</span>
                                                                                                                : r.valor_Descontado_Direito !== null && r.valor_Descontado_Direito !== undefined ?
                                                                                                                    <span style={{ color: "orange" }}> (R${moedaRealLocaleValue(r.valor_Descontado_Direito)})</span> : null}

                                                                                                        </Typography>
                                                                                                    </Grid>
                                                                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1}>
                                                                                                        <Typography variant="body1" >
                                                                                                            Contrato
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" >
                                                                                                            {r.tempo_Contrato} Anos
                                                                                                        </Typography>
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 3 }} display="flex"  >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                            <Box width="100%" display="flex" flexDirection="row" justifyItems="center" alignItems="center">
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center" textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        <Typography variant="body1" >
                                                                                                            Franquia Lance
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" >
                                                                                                            <span style={{ color: r.codigo_Franquia === codigoFranquia ? "#66bb6a" : "white" }}> {r.franquia_Lance_Jogador}</span>
                                                                                                        </Typography>
                                                                                                        <img src={r.logo_Franquia_Lance_Jogador === null ? showImagemFranquia : r.logo_Franquia_Lance_Jogador} alt={r.franquia_Lance_Jogador} width={50} height={50} />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent={"center"} textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        {r.franquia_Direitos_Jogador !== null ? (
                                                                                                            <><Typography variant="body1" >
                                                                                                                Franquia Direitos
                                                                                                            </Typography>
                                                                                                                <Typography variant="body2" >
                                                                                                                    <span style={{ color: r.codigo_Franquia_Direitos_Jogador === codigoFranquia ? "#117ED9" : "white" }}> {r.franquia_Direitos_Jogador}</span>
                                                                                                                </Typography>
                                                                                                                <img src={r.logo_Franquia_Direitos_Jogador === null ? showImagemFranquia : r.logo_Franquia_Direitos_Jogador} alt={r.franquia_Direitos_Jogador} width={50} height={50} />
                                                                                                            </>
                                                                                                        ) : <Typography variant="body1" >
                                                                                                            Livre
                                                                                                        </Typography>}

                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 4, md: 2 }} display="flex" justifyContent="center" textAlign="center" direction="column">
                                                                                        <Grid size={{ xs: 12, sm: 12 }}>
                                                                                            <Typography variant="body2" sx={{ color: handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white", }}>
                                                                                                Duração (Hrs):
                                                                                            </Typography>
                                                                                            {handleMostrarTemporizador(r.data_Fim_Lance) === 1 ?
                                                                                                UseCountdown(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white")
                                                                                                : UseDiff(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white")}
                                                                                            <Typography variant="body1" >
                                                                                                Tempo Final
                                                                                            </Typography>
                                                                                            <Typography variant="body2" >
                                                                                                {new Date(r.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(r.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 2 }} display="flex" justifyContent="center" alignItems="center" >
                                                                                        <Grid container size={{ xs: 12, sm: 6, md: 6 }} display={(user.codUsuario === r.codUsuCriacao || moment.tz(r.data_Fim_Lance,'America/Sao_Paulo') <= moment().tz('America/Sao_Paulo').locale('pt-BR') || r.aprovacao_Restrito) ? "none" : "flex"} direction="column" flex={2}>
                                                                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                <Button
                                                                                                    color="success"
                                                                                                    variant="outlined"
                                                                                                    disableElevation
                                                                                                    onClick={() => handleAumentarLeilao(r.codigo !== undefined ? r.codigo : 0)}
                                                                                                    startIcon={<Icon>check</Icon>}
                                                                                                    disabled={isLoading}
                                                                                                >
                                                                                                    <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                                                        Aumentar
                                                                                                    </Typography>
                                                                                                </Button>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                        {r.aprovacao_Restrito && (
                                                                                            <Grid container size={{ xs: 12, sm: 6, md: 6 }} display={!r.aprovacao_Restrito ? "none" : "flex"} direction="column" flex={2}>
                                                                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                    <Typography variant="body1" whiteSpace="pre-wrap" textOverflow="ellipsis" overflow="hidden" sx={{ color: "#66bb6a" }}>
                                                                                                        Aguardando a aprovação {r.franquia_Direitos_Jogador}
                                                                                                    </Typography>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        )}
                                                                                        {(user.administrador || //usuarioComissario ||
                                                                                            (
                                                                                                moment.tz(r.data_Fim_Lance,'America/Sao_Paulo') <= moment().tz('America/Sao_Paulo').locale('pt-BR')
                                                                                                && (codigoFranquia === r.codigo_Franquia || codigoFranquia === r.codigo_Franquia_Direitos_Jogador)
                                                                                            ))
                                                                                            && (
                                                                                                <Grid style={{ marginTop: "24px" }}>
                                                                                                    <Button
                                                                                                        color="success"
                                                                                                        variant="outlined"
                                                                                                        disableElevation
                                                                                                        fullWidth
                                                                                                        onClick={() => handleGerarContratoLance(r.codigo !== undefined ? r.codigo : 0)}
                                                                                                        startIcon={<Icon>check</Icon>}
                                                                                                        disabled={isLoading}
                                                                                                    >
                                                                                                        <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                                                            Finalizar Lance
                                                                                                        </Typography>
                                                                                                    </Button>
                                                                                                </Grid>
                                                                                            )}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    )
                                                            ))}
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {showGridFreeAgency && (
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} paddingBottom={3}>
                                                    <Grid container size={{ xs: 12, sm: 12 }}  >
                                                        <Grid size={{ xs: 12, sm: 12 }} display="flex" textAlign="initial" >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20 }}>Free Agency</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12 }}  >
                                                            <hr />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" spacing={UtilidadeService.isMobile() ? 2 : 1}  >
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                            <Autocomplete
                                                                openText="Abrir"
                                                                closeText="Fechar"
                                                                noOptionsText="Sem opções"
                                                                loadingText="Carregando..."
                                                                disablePortal
                                                                options={opcoesAutoCompleteJogador}
                                                                loading={isLoading}
                                                                disabled={isLoading}
                                                                value={autoCompleteSelectedOption}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}

                                                                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Jogador"
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                            <VTextMaskCustom
                                                                fullWidth
                                                                name="selecaoJogador"
                                                                disabled={isLoading}
                                                                label="Valor"
                                                                type="text"
                                                                typeMask="currency"
                                                                value={valorSalarioJogador}
                                                                onChange={e => { setValorSalarioJogador(e.target.value); handleDisableSave(); }}
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 },
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                            <FormControl fullWidth>
                                                                <InputLabel id="demo-simple-select-label">Anos</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-label"
                                                                    id="demo-simple-select"
                                                                    label="Anos"
                                                                    value={anoSelecionado}
                                                                    onChange={(e) => { setAnoSelecionado(Number(e.target.value)); setOpcoesContratoAjustavelRows([]); }}
                                                                    defaultValue={0}
                                                                    style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}
                                                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                >
                                                                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                                    {
                                                                        AnosTemporadas.map(qtd =>
                                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} display={contratoAjustado ? "flex" : "none"} alignItems="start" justifyContent="flex-start" justifyItems="start" textAlign="start" style={{ marginTop: UtilidadeService.isMobile() ? "20px" : "auto", maxWidth: "130px" }}>
                                                            <Button
                                                                color="info"
                                                                variant="outlined"
                                                                disableElevation
                                                                onClick={() => handleCalcularOpcao()}
                                                                startIcon={<Icon>calculate</Icon>}
                                                                disabled={isLoading}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                            >
                                                                <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                    Calcular
                                                                </Typography>
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12, md: 3, lg: 2, xl: 1 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end" style={{ marginTop: UtilidadeService.isMobile() ? "20px" : "auto", maxWidth: "130px" }}>
                                                            <Button
                                                                color="error"
                                                                variant="outlined"
                                                                disableElevation
                                                                onClick={() => setShowGridFreeAgency(false)}
                                                                startIcon={<Icon>cancel</Icon>}
                                                                disabled={isLoading}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                            >
                                                                <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                    Cancelar
                                                                </Typography>
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 6, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end" style={{ marginTop: UtilidadeService.isMobile() ? "20px" : "auto" }}>
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={handleSave}
                                                                endIcon={<Icon>add</Icon>}
                                                                disabled={desativar}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                            >
                                                                Salvar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    {contratoAjustado && (
                                                        <>
                                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} style={{ paddingTop: "20px" }}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Opção Contrato Ajustável</InputLabel>
                                                                        <Select
                                                                            name="tipo_Contrato_Ajustavel"
                                                                            label="Opção Contrato Ajustável"
                                                                            value={opcaoContratoAjustavel}
                                                                            onChange={(e) => { setOpcaoContratoAjustavel(Number(e.target.value)); }}
                                                                            defaultValue={1}>
                                                                            {
                                                                                lstDropTipoContratoAjustado.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }}  >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20 }}>Projeção</Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }}  >
                                                                <hr />
                                                            </Grid>
                                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                                <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto"  >
                                                                    <Box sx={{
                                                                        height: 'auto', width: '100%',
                                                                        '& .super-app-theme--header': {
                                                                            backgroundColor: theme.palette.common.black,
                                                                            color: theme.palette.common.white
                                                                        },
                                                                        '& .super-app.negative': {
                                                                            color: 'red',
                                                                            fontWeight: 'bold'
                                                                        },
                                                                        '& .super-app.positive': {
                                                                            color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.common.black
                                                                        },
                                                                    }}>
                                                                        <DataGrid
                                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                            autoHeight
                                                                            getRowId={(rows) => rows.tipo}
                                                                            rows={opcoesContratoAjustavelRows}
                                                                            columns={opcoesColumns}
                                                                            initialState={{
                                                                                pagination: {
                                                                                    paginationModel: {
                                                                                        pageSize: 12,
                                                                                    },
                                                                                },
                                                                            }}
                                                                            pageSizeOptions={[12]}
                                                                            disableRowSelectionOnClick
                                                                        />
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )}
                                                </Grid>
                                            )}
                                        </Grid>
                                    )
                                        : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" style={{ padding: 0 }}>
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20 }}>Free Agency fechado!</Typography>
                                            <hr />
                                        </Grid>
                                    }
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid container size={{ xs: 12, sm: 12 }} justifyContent="start" direction="row" gap={1}>
                                            <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
                                                <Autocomplete
                                                    openText="Abrir"
                                                    closeText="Fechar"
                                                    noOptionsText="Sem opções"
                                                    loadingText="Carregando..."
                                                    options={opcoesAutoCompleteJogador1}
                                                    loading={isLoading}
                                                    disabled={isLoading}
                                                    value={autoCompleteSelectedOption1}
                                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                    onChange={(event, newValue) => { setSelectedIdComplete1(newValue?.codigo); }}
                                                    popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Jogador"
                                                            slotProps={{
                                                                //   htmlInput:{
                                                                //     ...params.InputProps,
                                                                //     style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 }
                                                                //   },
                                                                inputLabel: {
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <SelectComponent
                                                    required
                                                    isExternalLoading={isLoading}
                                                    label="Temporadas"
                                                    name="codigo_Temporada"
                                                    items={lstTemporadas}
                                                    defaultValue={codigoTemporada}
                                                    variant="outlined"
                                                    onChange={e => setCodigoTemporada(Number(e.target.value))}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 3 }} display="flex" alignSelf={"center"} alignItems="center" justifyContent="end" style={{ padding: 8 }} >
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={() => CarregarDadosHistoricoFreeAgency()}
                                                    startIcon={<Icon>change_circle</Icon>}
                                                >
                                                    Pesquisar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={1}>
                                            <Typography variant="h6">Histórico</Typography>
                                            <hr />
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            {!removeLoading && <Loading />}
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }} padding={1}>
                                            {listaHistoricoLances.length > 0 ? (
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                        [' .${super-app-vencedor}.vencedor']: {
                                                            // backgroundColor: 'rgba(157, 255, 118, 0.49)',
                                                            color: '#118f3dff',
                                                            fontWeight: '600',
                                                        },
                                                        [' .${super-app-perdedor}.perdedor']: {
                                                            // backgroundColor: '#d47483',
                                                            color: themeName === "light" ? '#983813ff' : "#c24616",
                                                            fontWeight: '600',
                                                        },
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo}
                                                            rows={listaHistoricoLances}
                                                            columns={columnsHistorico}
                                                            columnVisibilityModel={{ codigo: false }}
                                                            rowHeight={75}
                                                            // initialState={{
                                                            //     pagination: {
                                                            //         paginationModel: {
                                                            //             pageSize: 25,
                                                            //         },
                                                            //     },
                                                            // }}
                                                            // pageSizeOptions={[25, 50, 100]}

                                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 12 : 13,
                                                                fontWeight: "bold"
                                                            }}
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            hideFooter
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                                :
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">Não possui histórico de lances</Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={1} paddingBottom={2}>
                                            <Typography variant="h6">REMOVER JOGADORES SEM CONTRATO</Typography>
                                            <hr />
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }} justifyContent="start" direction="row" gap={1} paddingBottom={1}>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} style={{ padding: 8 }} >
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={() => RemoverJogadores()}
                                                    startIcon={<HighlightOff />}
                                                >
                                                    Remover
                                                </Button>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} paddingTop={1}>
                                                <Typography variant="h6">Pesquisar</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 4, md: 4 }} >
                                                <SelectComponent
                                                    required
                                                    isExternalLoading={isLoading}
                                                    label="Temporadas"
                                                    name="codigo_Temporada"
                                                    items={lstTemporadas}
                                                    defaultValue={codigoTemporada}
                                                    variant="outlined"
                                                    onChange={e => { CarregarJogadoresRemovidos(Number(e.target.value)); }}
                                                />
                                            </Grid>

                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={1}>
                                            <Typography variant="h6">Histórico</Typography>
                                            <hr />
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            {!removeLoading && <Loading />}
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }} padding={1}>
                                            {listaJogadoresRemovidos.length > 0 ? (
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                        [' .${super-app-vencedor}.vencedor']: {
                                                            // backgroundColor: 'rgba(157, 255, 118, 0.49)',
                                                            color: '#118f3dff',
                                                            fontWeight: '600',
                                                        },
                                                        [' .${super-app-perdedor}.perdedor']: {
                                                            // backgroundColor: '#d47483',
                                                            color: themeName === "light" ? '#983813ff' : "#c24616",
                                                            fontWeight: '600',
                                                        },
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo}
                                                            rows={listaJogadoresRemovidos}
                                                            columns={columnsJogadoresRemovidos}
                                                            columnVisibilityModel={{ codigo: false }}
                                                            rowHeight={75}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 25,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[25, 50, 100]}

                                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 12 : 13,
                                                                fontWeight: "bold"
                                                            }}
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                                :
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">Não possui histórico de remoção</Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid >
                </Box >
            </VForm >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
};


